import { IPickerItemProps } from '@fluentui/react';
import * as React from 'react';
import { IAutocompletePickerOption } from '../../data-types/autocomplete/IAutocompletePickerOption';
import { IMvcAutoCompleteGroupModel } from '../../view-models/autocomplete/IMvcAutoCompleteGroupModel';
import { IMvcAutoCompleteModel } from '../../view-models/autocomplete/IMvcAutoCompleteModel';

import { SelectedAutocompleteItem } from './SelectedAutocompleteItem';

export function getRenderSelectedAutocompleteItemHandler(styles?: React.CSSProperties) {
    return (props: IPickerItemProps<IAutocompletePickerOption>) => (
        <SelectedAutocompleteItem
            key={props.key}
            item={props.item}
            styles={styles}
            index={props.index}
            disabled={props.disabled}
            onRemoveItem={props.onRemoveItem}
            removeButtonAriaLabel={props.removeButtonAriaLabel}
            removeButtonIconProps={props.removeButtonIconProps}
        />
    );
}

/// this will not perform well for very large unfiltered data sets.
/// we need a clean backend endpoint if performance becomes an issue
/// so we dont need to preprocess on every query.
export function convertAutoCompleteModelToAutocompleteOptions(
    json: Array<IMvcAutoCompleteGroupModel>,
    dataKey: 'Key' | 'Id' | 'Code' = 'Key'
): Array<IAutocompletePickerOption> {
    let returnArray = new Array<IAutocompletePickerOption>();
    if (json) {
        json.forEach((collection: IMvcAutoCompleteGroupModel, index: number) => {
            if (collection.Items && collection.Items.length > 0) {
                const options = collection.Items.map((i: IMvcAutoCompleteModel) => {
                    return { label: i.Label, key: i[dataKey], isGroup: collection.IsGroup };
                });
                returnArray.push(...options);
            }
        });
    }
    return returnArray;
}
